import { AssetData } from "./AssetData";

export class AssetDatabase {
  static storeName = "assets";
  static dbName = "localServerFileCache";

  assets = {};
  // json;
  dataInterface;
  loadFromJson(json) {
    this.assets = json;
    // if (this.json.db_version === undefined) {
    //   this.json.db_version = 1;
    // }
  }
  saveToJson() {
    return this.assets;
  }
  setDataInterface(dataInterface) {
    this.dataInterface = dataInterface;
  }

  async downloadNewAssets(server_asset_list) {
    await this.dataInterface?.downloadNewAssets(server_asset_list, this);
  }

  loadFromCacheOrUrl(assetObject, url,is_cache_enabled=true) {
    if (this.dataInterface && is_cache_enabled) {
      this.dataInterface.loadFromCacheOrUrl(this, assetObject, url);
    } else {
      assetObject.src = url;
    }
  }
}

export class AssetDataInterface {}

export class IndexedDBAssetDataInterface extends AssetDataInterface {
  db;

  constructor(db) {
    super();
    this.db = db;
  }

  downloadFile(url, info, asset_database) {
    let self = this;

    var p = new Promise((resolve) => {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.responseType = "blob";

      xhr.onload = function () {
        let data = { path: url, info: info };

        let transaction = self.db.transaction([AssetDatabase.storeName], "readwrite");
        let store = transaction.objectStore(AssetDatabase.storeName);

        let storeData = { path: url, info: info, data: this.response };
        var request = store.put(storeData);
        request.onerror = function (e) {
          let name = e.target.error.name;
          resolve(data);
        };
        request.onsuccess = function (e) {
          asset_database.assets[url] = data;
          console.log(`end download ${url}`);
          resolve(data);
        };
      };

      console.log(`start download ${url}`);
      xhr.send();
    });
    return p;
  }

  async downloadNewAssets(server_asset_list, asset_database) {
    let promises = [];

    for (const [key, value] of Object.entries(server_asset_list)) {
      if (key.startsWith("__")) {
        continue;
      }
      let found = asset_database.assets[key];

      if (found && found.info.hash == value.hash) {
        continue;
      }

      let p = this.downloadFile(key, value, asset_database);
      if (p) {
        promises.push(p);
      }
    }

    await Promise.all(promises);
  }

  loadFromCacheOrUrl(asset_database, assetObject, url) {
    let found = asset_database.assets[url];

    if (found) {
      let transaction = self.db.transaction([AssetDatabase.storeName], "readwrite");
      transaction.objectStore(AssetDatabase.storeName).get(url).onsuccess = function (event) {

        if(!event.target.result){
          assetObject.src = url;
          return;
        }
        
        var imgFile = event.target.result.data;

        console.log("load from cache: " + event.target.result.path);

        var URL = window.URL || window.webkitURL;

        var imgURL = URL.createObjectURL(imgFile);

        assetObject.onload = () => URL.revokeObjectURL(imgURL);
        assetObject.src = imgURL;
      };
    } else {
      assetObject.src = url;
    }
  }
}
